

export function getNotificationsEnabled() {
    return localStorage.getItem('notifications-enabled') === "true";
}

export function storeNotificationsEnabled(notificationsEnabled) {
    localStorage.setItem('notifications-enabled', notificationsEnabled);
}

export function getTopicSubscriptions() {
    return JSON.parse(localStorage.getItem('topic-subscriptions') ?? "[]");
}

export function storeTopicSubscriptions(subscriptions){
    localStorage.setItem('topic-subscriptions', JSON.stringify(subscriptions));
}